<template>
  <div class="n6">
    <h1 class="n6-title">{{title}}</h1>
    <p class="n6-info">{{info}}</p>
    <div class="n6-content">
      <ul>
        <li v-for="(item,index) of content" :key="index">
          <div
            class="n6-card"
            :class="{current:currentIndex===index}"
            @mouseenter="showCard(index)"
          >
            <div v-show="currentIndex!==index" @click="handleRoute(item)">
              <div class="n6-bgimg" :style="item.siteMenuDetail.imgUrls != null ? {backgroundImage:'url('+item.siteMenuDetail.imgUrls+')'} : ''">
                <h4 class="n6-caption">{{item.siteMenuDetail.title}}</h4>
                <div class="n6-mask"></div>
                <h4 class="n6-caption">{{item.siteMenuDetail.title}}</h4>
              </div>
              <div>
                <p></p>
              </div>
            </div>
            <div v-show="currentIndex===index" @click="handleRoute(item)">
              <div class="current-bg" :style="item.siteMenuDetail.imgUrls != null ? {backgroundImage:'url('+item.siteMenuDetail.imgUrls+')'} : ''">
                <div class="n6-current-mask"></div>
                <h4 class="n6-current-caption">{{item.siteMenuDetail.title}}</h4>
                <p class="current-desc">{{item.siteMenuDetail.subTitle}}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: "HomePart3",
  props:['info'],
  data() {
    return {
      currentIndex: 0,
      title: "产品中心",
      content: []
    };
  },
  created() {
    this.queryProduceList();
  },
  methods: {
    async queryProduceList() {
      const {data} = await request.get("/outSiteMenu/queryProduceList")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.content = data.data;
      }
    },

    handleRoute(row){
      if(row.jump === '4' || row.jump === '5'){
        window.open(row.path, '_blank');
        return;
      }
      this.$router.push({path: '/page' + row.jump , query: {id: row.id}});
    },

    showCard(index) {
      this.currentIndex = index;
    }
  }
};
</script>

<style scoped>
.n6 {
  text-align: center;
  background-size: cover;
  position: relative;
  background: linear-gradient(-1deg, #3c4255 0, #2a2f40 98%);
  height: 660px;
  color: #fff;
}
h1 {
  position: relative;
  display: inline-block;
  margin: 50px auto 20px;
  line-height: 30px;
  padding: 0 30px;
  font-weight: 400;
  font-size: 28px;
  color: #fff;
}
.n6-info {
  color: #fff;
}
h1::before {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_r.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  left: 100%;
}
h1::after {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_l.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  right: 100%;
}
.n6-content ul {
  display: flex;
  justify-content: center;
  padding: 0;
  margin-top: 60px;
  margin-bottom: 0;
}
.n6-content::after {
  content: "";
  clear: both;
  display: block;
}
.n6-card {
  position: relative;
  width: 200px;
  height: 390px;
  text-align: center;
  transition: opacity, height, margin 0.3s linear;
  overflow: hidden;
}
.n6-caption {
  position: absolute;
  color: #fff;
  z-index: 99;
  left: 0;
  right: 0;
  margin: auto;
  top: 40%;
}
.n6-current-caption {
  position: absolute;
  color: #fff;
  z-index: 99;
  left: 0;
  right: 0;
  margin: auto;
  top: 20%;
}
.current {
  position: relative;
  width: 280px;
  height: 380px;
  padding: 30px;
  margin-top: -25px;
  background-repeat: repeat;
  overflow: hidden;
}
.current-bg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.77;
  background: center;
  background-size: 100% 100%;
}
.n6-bgimg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.77;
  background: center;
  background-size: 100% 100%;
}
.n6-caption::after {
  content: " ";
  display: block;
  width: 30px;
  height: 4px;
  background: #40acff;
  margin: 16px auto 0 auto;
}
.n6-current-caption::after {
  content: " ";
  display: block;
  width: 30px;
  height: 4px;
  background: #40acff;
  margin: 16px auto 0 auto;
}
.n6-caption-l::after {
  content: " ";
  display: block;
  width: 30px;
  height: 2px;
  background: #108ced;
  margin: 16px auto 0 auto;
}
.n6-icon-l {
  width: 30px;
}
.n6-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.77;
  background-image: linear-gradient(-180deg, #364167 0, #0a0b13 100%);
}
.current-desc {
  position: absolute;
  margin: 0;
  padding: 200px 30px;
  font-size: 14px;
  line-height: 24px;
  font-size: 12px;
}
.n6-current-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.82;
  background-image: linear-gradient(-180deg, #3f6493 0, #1c192b 100%);
}
</style>